module.exports = __webpack_public_path__ + "static/img/钟祥刚总裁.e6782463.png";